<template style="height:100%">
  <div class="Dictionary_type">

    <div class="Dictionary_type_top">
      <el-form style="padding-top: 20px;margin-left: 20px;" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="字典类型">
          <el-select v-model="formInline.DicTypeID" placeholder="字典类型">
            <el-option v-for="item in alllist" :key="item.dictypeid" :label="item.dictypname" :value="item.dictypeid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="Dictionary_type_botom">
      <el-button type="primary" style="margin-left: 1%;margin-top: 10px;" @click="addfun()">新增</el-button>
      <el-table :data="tableData" style="width: 100%;margin-top: 20px;width: 98%;margin-left: 1%;">
        <el-table-column prop="cDicValue" label="字典名称"></el-table-column>
        <el-table-column prop="eDicValue" label="英文名称"></el-table-column>

        <!-- <el-table-column prop="dicKey" label="字典类别" width="180"></el-table-column> -->
<!-- 
        <el-table-column label="是否有效" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.isactive == 1">有效</span>
            <span v-else>无效</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="createddate" label="创建日期"></el-table-column> -->
        <!-- <el-table-column prop="remark" label="备注"></el-table-column> -->

        <el-table-column label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="copy_Button" @click="edit(scope.row)">修改</span>
            <!-- <span class="copy_Button" @click="del(scope.row)">删除</span> -->
            <el-popconfirm title="这是一段内容确定删除吗？" @confirm="del(scope.row)">
              <el-button class="copy_Button" style="padding: 0px;border: none;margin-left: 5px;"
                slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange"
        :current-page.sync="PageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    </div>

    <el-dialog class="el-dialogs" title="字典内容" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item  class="te" label="字典类型名称" prop="DicTypCode">
          <el-select v-model="ruleForm.DicTypCode" placeholder="字典类型名称" :disabled="pd">
            <el-option  v-for="item in alllist" :key="item.dictypeid" :label="item.dictypname" :value="item.dictypeid"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="字典名称" prop="CDicValue">
          <el-input v-model="ruleForm.CDicValue" placeholder="请输入字典类型编码"></el-input>
        </el-form-item>

        <el-form-item label="英文名称">
          <el-input v-model="ruleForm.EDicValue" placeholder="请输入英文名称"></el-input>
        </el-form-item>

        <el-form-item label="排序">
          <el-input v-model="ruleForm.LineNumber" placeholder="请输入排序"></el-input>
        </el-form-item>

        <!-- 
        <el-form-item label="描述">
          <el-input type="textarea" placeholder="请输入描述" v-model="ruleForm.Remark"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      DicKey:'',
      alllist:[],
      pd: false,
      dictypeid: '',
      Counts: 0,
      dialogVisible: false,
      formInline: {
        DicTypCode: '',
        DicTypeID: ''
      },
      PageIndex: 1,
      tableData: [],

      ruleForm: {
        DicTypCode: '',//字典类型编号
        CDicValue: '', //字典中文名称
        EDicValue: '',//字典英文名称
        LineNumber: '',//字典排序号
      },
      rules: {
        DicTypeName: [
          { required: true, message: '请输入字典类别名称', trigger: 'blur' }
        ],
        DicTypeCode: [
          { required: true, message: '请输入字典字典编码', trigger: 'change' }
        ],
      }
    };
  },
  components: {

  },
  methods: {
    edit(res) {
      this.pd = true;

      this.DicKey = res.dicKey;
      this.dictypeid = res.dictypeid;
      this.ruleForm = {
        DicTypCode: Number(res.dicTypCode),//字典类型编号
        CDicValue: res.cDicValue, //字典中文名称
        EDicValue: res.eDicValue,//字典英文名称
        LineNumber: res.lineNo,//字典排序号
      }
      this.dialogVisible = true;
    },

    del(row) {
      this.$Http_Post('User/delDictionaryLevelPage', { DicKey: row.dicKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.load();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    load() {
      this.$Http_Post('User/dictionaryLevelPage', {DicTypCode: this.formInline.DicTypeID, PageSize: 10, PageIndex: this.PageIndex }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data
          this.Counts = res.Counts
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    handleCurrentChange(val) {
      this.PageIndex = val;
      this.load();
    },

    onSubmit() {
      this.PageIndex = 1;
      this.load();
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },

    addfun() {
      this.dialogVisible = true;
      this.pd = false
      this.ruleForm = {
        DicTypCode: '',//字典类型编号
        CDicValue: '', //字典中文名称
        EDicValue: '',//字典英文名称
        LineNumber: '',//字典排序号
      }
    },

    submitForm(formName) {
      if (!this.pd) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.iscontinuous = true
            this.$Http_Post('User/addDictionaryLevelPage', {
              DicTypCode: this.ruleForm.DicTypCode,
              CDicValue: this.ruleForm.CDicValue,
              EDicValue: this.ruleForm.EDicValue,
              LineNumber: this.ruleForm.LineNumber,
            }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.iscontinuous = false
                this.Global.request_successful(res.Message);
                this.load()
                this.dialogVisible = false;
                this.ruleForm = {
                  DicTypCode: '',
                  CDicValue: '', 
                  EDicValue: '',
                  LineNumber: '',
                }
              } else {
                this.iscontinuous = false
                this.Global.request_failure(res.Message);
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$Http_Post('User/editDictionaryLevelPage', {
              DicKey: this.DicKey,
              DicTypCode: this.ruleForm.DicTypCode,
              CDicValue: this.ruleForm.CDicValue,
              EDicValue: this.ruleForm.EDicValue,
              LineNumber: this.ruleForm.LineNumber,
            }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.Global.request_successful(res.Message);
                this.dialogVisible = false;
                this.ruleForm = {
                  DicTypCode: '',
                  CDicValue: '',
                  EDicValue: '',
                  LineNumber: '',
                }
                this.load()
              } else {
                this.Global.request_failure(res.Message);
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }

    },
  },
  mounted() {
    this.$Http_Post('User/dictionaryTypePage', { DicTypeID: '', DicTypCode: '', PageSize: 10000, PageIndex: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.alllist = res.Data;
        this.formInline.DicTypeID = this.alllist[0].dictypeid;
        this.load();
      } else {
        this.Global.request_failure(res.Message);
      }
    });
  }
};
</script>
<style>
.Dictionary_type {
  height: 100%;
  width: 100%;
  background-color: rgb(235, 236, 237);
}

.Dictionary_type .Dictionary_type_top {
  height: 80px;
  background-color: #fff;
}

.Dictionary_type_botom {
  margin-top: 20px;
  background-color: #fff;
  height: calc(100% - 100px);
}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}

.Dictionary_type .el-dialogs .el-form-item__label {
  width: 110px !important;
  text-align: right;
}

.Dictionary_type .el-dialogs .el-form-item__content {
  margin-left: 120px !important;
}

.Dictionary_type .el-dialogs .el-input__inner {
  width: 80%;
}
.te .el-input__inner {
  width: 100% !important;
}
</style>